import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import Loader from "../components/Loader"

const ProtectedRoute = ({ element, role }) => {
  const { user, isLoading } = useAuth();

  console.log("🔹 ProtectedRoute - Vérification de l'accès", { user, isLoading });

  if (isLoading) {
    return <Loader />;
  }

  if (!user) {
    console.warn("❌ `ProtectedRoute` - Redirection forcée car `user` est null !");
    return <Navigate to="/login" replace />;
  }

  if (role && user.role !== role) {
    console.warn("⚠️ `ProtectedRoute` - Redirection vers `/dashboard` car `user.role` ne correspond pas !");
    return <Navigate to="/dashboard" replace />;
  }

  return element;
};

export default ProtectedRoute;
